import React, { useState } from 'react';
import { FaCopy, FaCheck } from 'react-icons/fa';

const LiveAddress = ({ data }) => {
  const [copiedField, setCopiedField] = useState(null);

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 2000); // Reset after 2 seconds
  };

  if (!data) return null;

  return (
    <div className="mt-6 p-4 bg-white rounded-lg border border-gray-200">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Alamat Penghantaran</h2>
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium text-gray-600">Nama</label>
          <div className="flex items-center justify-between mt-1 p-2 bg-gray-50 rounded-md">
            <p className="text-gray-800">{data.name}</p>
            <button
              onClick={() => handleCopy(data.name, 'name')}
              className="text-gray-500 hover:text-gray-700 transition-colors"
              title="Copy name"
            >
              {copiedField === 'name' ? (
                <FaCheck className="text-green-500" />
              ) : (
                <FaCopy />
              )}
            </button>
          </div>
        </div>

        <div>
          <label className="text-sm font-medium text-gray-600">Nombor Telefon</label>
          <div className="flex items-center justify-between mt-1 p-2 bg-gray-50 rounded-md">
            <p className="text-gray-800">{data.phone}</p>
            <button
              onClick={() => handleCopy(data.phone, 'phone')}
              className="text-gray-500 hover:text-gray-700 transition-colors"
              title="Copy phone number"
            >
              {copiedField === 'phone' ? (
                <FaCheck className="text-green-500" />
              ) : (
                <FaCopy />
              )}
            </button>
          </div>
        </div>

        <div>
          <label className="text-sm font-medium text-gray-600">Alamat</label>
          <div className="flex items-center justify-between mt-1 p-2 bg-gray-50 rounded-md">
            <p className="text-gray-800 whitespace-pre-line flex-1">{data.address}</p>
            <button
              onClick={() => handleCopy(data.address, 'address')}
              className="text-gray-500 hover:text-gray-700 transition-colors ml-2"
              title="Copy address"
            >
              {copiedField === 'address' ? (
                <FaCheck className="text-green-500" />
              ) : (
                <FaCopy />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveAddress;
